import { generatePath } from 'react-router-dom';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Response, Pagination } from '@ui/src';
import { SicCode } from '../../../types';
import { corporateClientsRiskApi } from '../services';
import ROUTES from '../../../../routes';

export interface CorporateClientsSicCodesState {
  list?: SicCode[];
  sicCode?: SicCode;
  document?: File;
  uploadSuccess?: boolean;
  sort?: {
    sortProp: string;
    sortDir: string;
  };
  pagination?: Pagination;
  uploadInProgress: boolean;
}

const initialState: CorporateClientsSicCodesState = {
  list: undefined,
  sort: undefined,
  uploadInProgress: false,
};

export const corporateClientsSicCodesSlice = createSlice({
  name: 'corporateClientsSicCodes',
  initialState,
  reducers: {
    onFileUpload: (state, action: PayloadAction<File>) => {
      state.uploadInProgress = true;
      state.document = action.payload;
      state.uploadSuccess = false;
    },
    onFileUploadSuccess: (state) => {
      state.uploadInProgress = false;
      state.uploadSuccess = true;
      state.document = undefined;
    },
    onSortList: (
      state,
      action: PayloadAction<{ name: string; direction: 'asc' | 'desc' }>,
    ) => {
      state.sort = {
        sortDir: action.payload.direction,
        sortProp: action.payload.name,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      corporateClientsRiskApi.endpoints.getSicCodes.matchFulfilled,
      (state, action: PayloadAction<Response<SicCode>>) => {
        state.list = action.payload.data.edges.map((item) => ({
          ...item.node,
          url: generatePath(ROUTES.CORPORATE_CLIENTS_RISK_SIC_CODE, {
            id: item.node.id,
          }),
          riskCategory: '-',
        }));

        state.pagination = action.payload.data.pageInfo;
      },
    );
    builder.addMatcher(
      corporateClientsRiskApi.endpoints.getSicCode.matchFulfilled,
      (state, action: PayloadAction<{ data: SicCode }>) => {
        state.sicCode = action.payload.data;
      },
    );
    builder.addMatcher(
      corporateClientsRiskApi.endpoints.updateSicCodeRiskScore.matchFulfilled,
      (state, action: PayloadAction<{ data: SicCode }>) => {
        state.list = state.list?.map((item) => {
          const result = { ...item };

          if (result.id === action.payload.data.id) {
            result.riskScore = action.payload.data.riskScore;
          }

          return result;
        });
      },
    );
  },
});

export const { onSortList, onFileUpload, onFileUploadSuccess } =
  corporateClientsSicCodesSlice.actions;

export default corporateClientsSicCodesSlice.reducer;
